import { DateTime, Duration } from 'luxon';
import {
  ExternalCalendarEventSummary,
  Opening,
  Reservation,
  TimeZone,
} from '../types';
import isBookedExternally from './isBookedExternally';
import isBookedInternally from './isBookedInternally';

//Find the first available opening for a FlexCal (Scheduling Link) to autonavigate to
const findFirstAvailableOpening = (
  openings: Opening[],
  externalEvents: ExternalCalendarEventSummary[],
  reservations: Reservation[],
  bookingBuffer: number,
  timeZone: TimeZone,
  endSearch: DateTime
): Date | undefined => {
  const timeSlots: Date[] = [];
  //Loop through all opening objects for this Flex Cal (Scheduling Link)
  openings.forEach((opening) => {
    //Create a luxon Duration object for the time-span of this opening
    const openingDuration = DateTime.fromISO(opening.endDate).diff(
      DateTime.fromISO(opening.startDate),
      'minutes'
    );

    //Loop through all duration objects for the this opening
    opening.durations?.forEach((duration) => {
      //Convert C# TimeSpan to Luxon Duration
      const slotDuration = Duration.fromISOTime(duration);
      //Calculate the number of timeslots for this opening by dividing the opnening duration by the timeslot duration
      const numTimeSlots = openingDuration.toMillis() / slotDuration.toMillis();
      //Loop through through timeslots and create FullCalendar Event objects for each
      let previousEndTime = DateTime.fromISO(opening.startDate);
      for (let i = 0; i < numTimeSlots; i++) {
        //set timeslot end time
        const newEndTime = previousEndTime.plus(slotDuration);
        //Timeslot times set with correct timeZone
        const eventStart = previousEndTime.setZone(timeZone.tzdbId);
        const eventEnd = newEndTime.setZone(timeZone.tzdbId);
        //Filter out events that are inside bookingBuffer
        if (
          previousEndTime.toMillis() >=
            DateTime.now().plus({ hours: bookingBuffer }).toMillis() &&
          !isBookedExternally(eventStart, eventEnd, externalEvents) &&
          !isBookedInternally(eventStart, eventEnd, reservations) &&
          eventStart < endSearch &&
          eventEnd < endSearch
        )
          timeSlots?.push(previousEndTime.toJSDate());
        //Set next timeslot range
        previousEndTime = newEndTime;
      }
    });
  });
  if (timeSlots.length === 0) return undefined;
  // return earliest timeslot in array
  return timeSlots.reduce((pre, cur) => {
    if (pre && cur) {
      return pre > cur ? cur : pre;
    }
    return pre;
  });
};

export default findFirstAvailableOpening;
